import React from 'react';

var TransferRUSurePopup = React.createClass({
	handleCancelClick: function(){
		this.props.transferRUSure("close");
	},
	handleTransferClick: function(){
		this.props.transferRUSure("submit", this.props.data);
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function (){
		return (
				 <div className="modal__mask" onClick = {this.handleCancelClick}>
				  	<div className="modal__content modal--sm" onClick = {this.handleStopPropogation}> 
				  		<a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}>
				  			<i className="fa  fa-close"> </i>
				  		</a>
					    <div className="modal__body clearfix">
					      	<div className="form__row">
					        	<p>Are you sure you want to transfer package <strong>"{this.props.slug}"</strong> to <strong>{this.props.data}</strong>? You will no longer have access to <strong>"{this.props.slug}"</strong>.</p>
					      	</div>
					      	<div className="form__row last clearfix">
					        	<div className="radiobox align-left">
					          		<label htmlFor="andres_site_V2">
					            	<input value="None" id="andres_site_V2" name="radio" type="radio"/>
					            	Do not ask me again. </label>
					        	</div>
						        <div className="buttons">
						          	<button className="btn__md bg-very_light" onClick = {this.handleCancelClick}>Cancel</button>
						          	<button className="btn__md bg-dark" onClick = {this.handleTransferClick}>Transfer</button>
						        </div>
					      	</div>
					    </div>
				  	</div>
				</div>
			);
	}
});

export {TransferRUSurePopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/TransferRUSurePopup.jsx
 **/